import React, { PureComponent } from 'react';

interface IFinancialsLevel2TabsTemplateProps {
    source: any;
}

export class FinancialsLevel2TabsTemplate extends PureComponent<IFinancialsLevel2TabsTemplateProps, any> {
    constructor(props: IFinancialsLevel2TabsTemplateProps) {
        super(props);
    }

    public render() {
        return (
            <span className="financialsLevel2Tabs-template-part" >
                this is financialsLevel2Tabs-template-part
            </span>
        );
    }
}

export default FinancialsLevel2TabsTemplate;
